import './EventsFilter.css';

const RADIUS_OPTIONS = [5, 10, 25, 50, 100];

function EventsFilter({ radius, onRadiusChange }) {
  const radiusOptions = [...new Set([...RADIUS_OPTIONS, radius])].sort((a, b) => a - b);

  return (
    <div className="events-filter">
      <div className="filter-group">
        <label className="filter-label" htmlFor="radius-select">Radius</label>
        <select
          id="radius-select"
          className="filter-select"
          value={radius}
          onChange={(e) => onRadiusChange(Number(e.target.value))}
        >
          {radiusOptions.map(r => (
            <option key={r} value={r}>{r} km</option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default EventsFilter;